<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="17" viewBox="0 0 15 17">
    <g id="delete-forever" transform="translate(0.5 0.5)">
      <g id="Group_1227" data-name="Group 1227">
        <path
          id="Path_4614"
          data-name="Path 4614"
          d="M2.5,5.5V14a1.573,1.573,0,0,0,1.636,1.5h8.727A1.573,1.573,0,0,0,14.5,14V5.5"
          transform="translate(-1.5 0.5)"
          fill="none"
          stroke="#991e66"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
        <line
          id="Line_260"
          data-name="Line 260"
          x2="14"
          transform="translate(0 3.467)"
          fill="none"
          stroke="#991e66"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
        <path
          id="Path_4615"
          data-name="Path 4615"
          d="M5.5,3.5V.5h5v3"
          transform="translate(-1 -0.5)"
          fill="none"
          stroke="#991e66"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
        <line
          id="Line_261"
          data-name="Line 261"
          y1="5"
          x2="5"
          transform="translate(4.5 7.7)"
          fill="none"
          stroke="#991e66"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
        <line
          id="Line_262"
          data-name="Line 262"
          x1="5"
          y1="5"
          transform="translate(4.5 7.7)"
          fill="none"
          stroke="#991e66"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
      </g>
    </g>
  </svg>
</template>
